<div class="page-section series-form-page">
    <div class="app-l-page__navigation">
        <div
            class="app-l-page__previous"
            [routerLink]="['/admin/organization-listing']">
            <button
                class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
                <svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
            </button>
        </div>
        <div class="app-l-page__breadcrumbs">
            <ul class="breadcrumbs-list">
                <li class="breadcrumbs-list-item">
                    <a [routerLink]="['/admin/organization-listing']"
                        >Organizations</a
                    >
                </li>
                <li class="breadcrumbs-list-item app-l-current-page">
                    {{ title }}
                </li>
            </ul>
        </div>
    </div>
    <div class="page-section-content">
        <page-loader *ngIf="!isLoaded"></page-loader>
        <div *ngIf="isLoaded">
            <form novalidate [formGroup]="orgEditForm" (ngSubmit)="doSave()">
                <my-tabs>
                    <my-tab [tabTitle]="'From CRM'">
                        <div class="form-wrapper-80">
                            <h2>CRM Fields</h2>
                            <div>
                                <div class="app-c-form-group">
                                    <label class="app-c-form--label"
                                        >Sugar ID</label
                                    >
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="
                                            organization?.crmGroup?.sugar_id_c
                                        "
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label"
                                        >Sugar Account Name</label
                                    >
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="
                                            organization?.crmGroup?.sugar_name
                                        "
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label"
                                        >Welltrack Connect Account Id</label
                                    >
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="
                                            organization?.crmGroup
                                                ?.connect_account_id_c
                                        "
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label"
                                        >Welltrack Boost Status</label
                                    >
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="
                                            organization?.crmGroup
                                                ?.boost_status_c
                                        "
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label"
                                        >Welltrack Connect Status</label
                                    >
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="
                                            organization?.crmGroup
                                                ?.connect_status_c
                                        "
                                        readonly
                                        type="text" />
                                </div>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label"
                                        >Assigned to RM User</label
                                    >
                                    <input
                                        class="app-c-form-control field-disabled"
                                        [value]="
                                            organization?.crmGroup
                                                ?.assigned_user_name
                                        "
                                        readonly
                                        type="text" />
                                </div>
                            </div>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'Basic Details'">
                        <div class="form-wrapper-80">
                            <h2>Basic Details</h2>
                            <div class="app-c-form-group">
                                <label
                                    class="app-c-form--label"
                                    for="organizationName"
                                    >Display Name</label
                                >
                                <img
                                    alt="Full name"
                                    *ngIf="fullName"
                                    src="./assets/img/icons/check@2x.png"
                                    class="check animated fadeInUp"
                                    item-content />
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="name"
                                    id="organizationName" />
                                <div
                                    class="error-message"
                                    *ngIf="
                                        f.name.touched &&
                                        f.name.errors?.required
                                    ">
                                    The organization needs a name.
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label" for="serviceType" translate>Service Type</label>
                                <select class="app-c-form-control" formControlName="ServiceType" id="serviceType">
                                    <option [value]="null">None</option>
                                    <option *ngFor="let service of serviceType" [value]="service.id">
                                        {{ service.name }}
                                    </option>
                                </select>
                                <div class="error-message"
                                    *ngIf="f.ServiceType.touched && f.ServiceType.errors?.required">
                                    The organization needs a service type.
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label" for="serviceTier" translate>Service Tier</label>
                                <select class="app-c-form-control" formControlName="ServiceTier" id="serviceTier">
                                    <option [value]="null">None</option>
                                    <option *ngFor="let service of serviceTier" [value]="service.name">
                                        {{ service.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label" for="parentId" translate>Parent Org</label>
                                <select
                                    class="app-c-form-control"
                                    formControlName="parentOrgId"
                                    id="parentId"
                                    [attr.disabled]="organization.childOrganizations ? true : null">
                                    <option [value]="null">None</option>
                                    <option *ngFor="let org of organizations" [value]="org.id">
                                        {{ org.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="app-c-form-group number-field">
                                <label
                                    class="app-c-form--label"
                                    for="eligiblePopulation"
                                    >Eligible Population</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="number"
                                    min="0"
                                    formControlName="eligiblePopulation"
                                    id="eligiblePopulation" />
                                <div
                                    class="error-message"
                                    *ngIf="
                                        f.eligiblePopulation.touched &&
                                        !f.eligiblePopulation.valid
                                    ">
                                    Invalid count.
                                </div>
                            </div>

                            <div class="icon-input">
                                <input
                                    type="checkbox"
                                    formControlName="demoStatus"
                                    id="demoStatus" />
                                <label for="demoStatus" translate
                                    >Demo/Trial</label
                                >
                            </div>

                            <div class="icon-input">
                                <input
                                    type="checkbox"
                                    formControlName="active"
                                    id="active" />
                                <label for="active">Active</label>
                            </div>

                            <div>
                                <img
                                    [alt]="organization.name"
                                    *ngIf="organization.logoPath"
                                    [src]="organization.logoPath"
                                    style="
                                        max-width: 300px;
                                        max-height: 200px;
                                        height: auto;
                                    " />
                            </div>

                            <div class="icon-input">
                                <label for="logo">Logo</label>
                                <input
                                    type="file"
                                    (change)="changeListener($event)"
                                    #input />
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Address</label>
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="address"
                                    id="address" />
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Phone</label>
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="phone"
                                    id="phone"
                                    placeholder="(xxx) xxx-xxxx / xxx-xxxx,,x,,x,x" />
                                <div
                                    class="error-message"
                                    *ngIf="f.phone.touched && !f.phone.valid">
                                    Invalid phone number.
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label">Website</label>
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="website"
                                    id="website" />
                                <div
                                    class="error-message"
                                    *ngIf="
                                        f.website.touched && !f.website.valid
                                    ">
                                    Invalid url
                                </div>
                            </div>

                            <div class="app-c-form-group">
                                <label class="app-c-form--label"
                                    >Protocall account reference ID</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="protocallRefId"
                                    id="protocallRefId" />
                            </div>

                            <div class="icon-input">
                                <label for="emergencyContact" translate
                                    >Emergency Contact</label
                                >
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="emergencyContact"
                                    [config]="config"
                                    id="emergencyContact">
                                </ckeditor>
                            </div>

                            <div class="icon-input">
                                <label for="description" translate
                                    >Description</label
                                >
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="description"
                                    [config]="config"
                                    id="description"></ckeditor>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Protocall Helpline'">
                        <div class="form-wrapper-80">
                            <div
                                id="protocall-helpline"
                                formGroupName="contactGroup">
                                <h2>Protocall Helpline</h2>
                                <div class="app-c-form-group">
                                    <label
                                        class="app-c-form--label"
                                        for="protocallTelephone"
                                        >Phone number</label
                                    >
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="telephone"
                                        id="protocallTelephone"
                                        placeholder="(xxx) xxx-xxxx / xxx-xxxx,,x,,x,x" />
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            contactGroup.controls['telephone']
                                                .touched &&
                                            !contactGroup.controls['telephone']
                                                .valid
                                        ">
                                        Invalid emergency contact phone number.
                                    </div>
                                </div>

                                <div class="app-c-form-group">
                                    <label
                                        class="app-c-form--label"
                                        for="protocallTitle"
                                        >Title</label
                                    >
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="title"
                                        id="protocallTitle" />
                                </div>

                                <div class="app-c-form-group">
                                    <label
                                        class="app-c-form--label"
                                        for="protocallDescription"
                                        >Description</label
                                    >
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="description"
                                        id="protocallDescription" />
                                </div>

                                <div class="icon-input">
                                    <label for="description" translate
                                        >Get Help Now Description</label
                                    >
                                    <ckeditor
                                        [editor]="Editor"
                                        formControlName="getHelpDescription"
                                        [config]="config"
                                        id="description">
                                    </ckeditor>
                                </div>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Config'">
                        <div class="config-container">
                            <div class="config-block config-block--wide">
                                <div class="config-block__header">
                                    <span class="config-block__title"
                                        >Series</span
                                    >
                                </div>

                                <section
                                    class="config-section"
                                    formGroupName="courses">
                                    <header class="config-section__header">
                                        <h4 class="config-section__title">
                                            Video Series
                                        </h4>
                                    </header>
                                    <div class="config-section__grid">
                                        <label
                                            class="app-c-checkbox"
                                            *ngFor="
                                                let course of courseList.controls;
                                                let i = index
                                            "
                                            [formGroupName]="i">
                                            <input
                                                type="checkbox"
                                                id="course-{{ i }}"
                                                formControlName="enabled" />
                                            <span>{{ course.value.name }}</span>
                                        </label>
                                    </div>
                                </section>

                                <section
                                    class="config-section"
                                    formGroupName="storiesConfig">
                                    <header class="config-section__header">
                                        <h4 class="config-section__title">
                                            Stories
                                        </h4>
                                    </header>
                                    <div class="config-section__grid">
                                        <label
                                            class="app-c-checkbox"
                                            *ngFor="
                                                let story of storyList.controls;
                                                let k = index
                                            "
                                            [formGroupName]="k">
                                            <input
                                                type="checkbox"
                                                id="story-{{ k }}"
                                                formControlName="enabled" />
                                            <span>{{ story.value.name }}</span>
                                        </label>
                                    </div>
                                </section>

                                <section
                                    class="config-section"
                                    formGroupName="burningQuestionsConfig">
                                    <header class="config-section__header">
                                        <h4 class="config-section__title">
                                            Burning Questions
                                        </h4>
                                    </header>
                                    <div class="config-section__grid">
                                        <label
                                            class="app-c-checkbox"
                                            *ngFor="
                                                let burningQuestion of burningQuestionList.controls;
                                                let k = index
                                            "
                                            [formGroupName]="k">
                                            <input
                                                type="checkbox"
                                                id="burningQuestion-{{ k }}"
                                                formControlName="enabled" />
                                            <span>{{
                                                burningQuestion.value.name
                                            }}</span>
                                        </label>
                                    </div>
                                </section>

                                <section class="config-section">
                                    <header class="config-section__header">
                                        <h4 class="config-section__title">
                                            Daily Series
                                        </h4>
                                    </header>
                                    <div class="config-section__grid">
                                        <label class="app-c-checkbox">
                                            <input
                                                type="checkbox"
                                                formControlName="enableDailySeries"
                                                id="enableDailySeries" />
                                            <span>Daily Boost</span>
                                        </label>
                                    </div>
                                </section>

                                <section
                                    class="config-section"
                                    formGroupName="readsConfig">
                                    <header class="config-section__header">
                                        <h4 class="config-section__title">
                                            Reads
                                        </h4>
                                    </header>
                                    <div class="config-section__grid">
                                        <label
                                            class="app-c-checkbox"
                                            *ngFor="
                                                let read of readsList.controls;
                                                let k = index
                                            "
                                            [formGroupName]="k">
                                            <input
                                                type="checkbox"
                                                id="read-{{ k }}"
                                                formControlName="enabled" />
                                            <span>{{ read.value.name }}</span>
                                        </label>
                                    </div>
                                </section>
                            </div>

                            <div class="config-block">
                                <div class="config-block__header">
                                    <span class="config-block__title"
                                        >Enabled Assessments</span
                                    >
                                </div>
                                <section
                                    class="config-section"
                                    formGroupName="assessmentConfig">
                                    <div class="config-section__grid">
                                        <label
                                            class="app-c-checkbox"
                                            *ngFor="
                                                let assessment of assessmentList.controls;
                                                let i = index
                                            "
                                            [formGroupName]="i">
                                            <input
                                                type="checkbox"
                                                [disabled]="
                                                    [
                                                        'mentalwellbeing',
                                                    ].includes(
                                                        assessment.value.key
                                                    )
                                                "
                                                id="assessment-{{ i }}"
                                                formControlName="enabled" />
                                            <span translate>{{
                                                assessment.value.name
                                            }}</span>
                                        </label>
                                    </div>
                                </section>
                            </div>

                            <div class="config-block">
                                <div class="config-block__header">
                                    <span class="config-block__title"
                                        >Enabled Tools</span
                                    >
                                </div>
                                <section
                                    class="config-section"
                                    formGroupName="toolsConfig">
                                    <div class="config-section__grid">
                                        <label
                                            class="app-c-checkbox"
                                            *ngFor="
                                                let tool of toolsList.controls;
                                                let i = index
                                            "
                                            [formGroupName]="i">
                                            <input
                                                type="checkbox"
                                                id="tool-{{ i }}"
                                                formControlName="enabled" />
                                            <span translate>{{
                                                tool.value.name
                                            }}</span>
                                        </label>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Settings'">
                        <div class="form-wrapper-80">
                            <div id="settingsSection" formGroupName="settings">
                                <h2>Settings</h2>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="hasCounselors"
                                        id="hasCounselors" />
                                    <label for="hasCounselors">{{
                                        this.customOrgTextKey
                                            ? 'Enable sync with CYFD Worker and invite to share?'
                                            : ('Enable sync with counselor and invite to share?'
                                              | translate)
                                    }}</label>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enableAlerts"
                                        id="enableAlerts" />
                                    <label for="enableAlerts"
                                        >Enable general DASS alerts for
                                        individual to synced counselor</label
                                    >
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="hasAssessmentAlerts"
                                        id="hasAssessmentAlerts" />
                                    <label for="hasAssessmentAlerts"
                                        >Enable HIGH DASS alerts to org
                                        admin</label
                                    >
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="disableFeedbackSurveys"
                                        id="disableFeedbackSurveys" />
                                    <label for="disableFeedbackSurveys"
                                        >Disable user feedback surveys?</label
                                    >
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="hideNotes"
                                        id="hideNotes" />
                                    <label for="hideNotes"
                                        >Hide notes (disable text fields: e.g.
                                        moodcheck notes, thought diary)?</label
                                    >
                                </div>

                                <div class="icon-input">
                                    <label for="website"
                                        >Custom validation checkbox (Enter text
                                        or leave blank to disable)</label
                                    >
                                    <ckeditor
                                        [editor]="Editor"
                                        formControlName="customConfirm"
                                        id="customConfirm"
                                        [config]="config">
                                    </ckeditor>
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="hasScheduledPushNotification"
                                        id="hasScheduledPushNotification" />
                                    <label for="hasScheduledPushNotification"
                                        >Enable Scheduled Push
                                        Notifications</label
                                    >
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="showWelltrackConnect"
                                        id="showWelltrackConnect" />
                                    <label for="showWelltrackConnect"
                                        >Show link to WellTrack Connect in
                                        series</label
                                    >
                                </div>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enableAnnouncements"
                                        id="enableAnnouncements" />
                                    <label for="enableAnnouncements"
                                        >Enable Custom Announcements</label
                                    >
                                </div>
                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enableOrganizationOwnContents"
                                        id="enableOrganizationOwnContents" />

                                    <label for="enableOrganizationOwnContents"
                                        >Show Organization's Own Content
                                        Section</label
                                    >
                                </div>

                                <div
                                    class="organization-own-content-titles"
                                    *ngIf="
                                        settings.controls[
                                            'enableOrganizationOwnContents'
                                        ].value
                                    ">
                                    <div class="app-c-form-group">
                                        <label class="app-c-form--label"
                                            >Organization's Own Content Section
                                            Title (English)</label
                                        >
                                        <input
                                            class="app-c-form-control"
                                            type="text"
                                            formControlName="organizationOwnContentTitleEn"
                                            id="organizationOwnContentTitleEn"
                                            placeholder="Enter the title (English)" />
                                        <div
                                            class="error-message"
                                            *ngIf="
                                                settings.controls[
                                                    'organizationOwnContentTitleEn'
                                                ].touched &&
                                                settings.controls[
                                                    'organizationOwnContentTitleEn'
                                                ].errors?.required
                                            ">
                                            The Title (English) is required
                                        </div>
                                        <div
                                            class="error-message"
                                            *ngIf="
                                                settings.controls[
                                                    'organizationOwnContentTitleEn'
                                                ].errors?.maxlength
                                            ">
                                            The Title (English) must be 32
                                            characters or less
                                        </div>
                                    </div>

                                    <div class="lang-Btn">
                                        <a
                                            class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                                            (click)="
                                                toggleField('French', 'Title')
                                            ">
                                            French Title
                                        </a>
                                        <a
                                            class="app-c-btn app-c-btn--secondary app-c-btn--curve app-c-btn--sm"
                                            (click)="
                                                toggleField('Spanish', 'Title')
                                            ">
                                            Spanish Title
                                        </a>
                                    </div>

                                    <div
                                        class="app-c-form-group"
                                        *ngIf="showTitleFrench">
                                        <label class="app-c-form--label"
                                            >Organization's Own Content Section
                                            Title (French)</label
                                        >
                                        <input
                                            class="app-c-form-control"
                                            type="text"
                                            formControlName="organizationOwnContentTitleFr"
                                            id="organizationOwnContentTitleFr"
                                            placeholder="Enter the title (French)" />
                                    </div>

                                    <div
                                        class="app-c-form-group"
                                        *ngIf="showTitleSpanish">
                                        <label class="app-c-form--label"
                                            >Organization's Own Content Section
                                            Title (Spanish)</label
                                        >
                                        <input
                                            class="app-c-form-control"
                                            type="text"
                                            formControlName="organizationOwnContentTitleEs"
                                            id="organizationOwnContentTitleEs"
                                            placeholder="Enter the title (Spanish)" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Signin Details'">
                        <div class="form-wrapper-80">
                            <div id="sso">
                                <h2 class="form-section-title">
                                    Signin Details
                                </h2>

                                <p class="form-help-text">
                                    The subdomain provides a link in the form of
                                    https://subdomain.welltrack-boost.com. This
                                    is used for displaying the org logo.
                                </p>

                                <div class="app-c-form-group">
                                    <label class="app-c-form--label" translate
                                        >Subdomain</label
                                    >
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="subdomain"
                                        id="subdomain" />
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            f.subdomain.touched &&
                                            f.subdomain.errors?.required
                                        ">
                                        The organization needs a subdomain.
                                    </div>
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            f.subdomain.touched &&
                                            !f.subdomain.errors?.required &&
                                            !f.subdomain.valid
                                        ">
                                        Invalid url
                                    </div>
                                </div>

                                <p class="form-help-text">
                                    Users will be automatically associated to
                                    the organization using one of the listed
                                    domains below. If there are multiple
                                    domains, provide them in a comma delimited
                                    list (domain1.org, domain2.org).
                                </p>

                                <div class="app-c-form-group">
                                    <label
                                        class="app-c-form--label"
                                        for="allowedDomains"
                                        translate
                                        >Known Domains</label
                                    >
                                    <input
                                        class="app-c-form-control"
                                        type="text"
                                        formControlName="allowedDomains"
                                        id="allowedDomains" />
                                </div>

                                <p class="form-help-text">
                                    The enforce domain setting will force users
                                    to use their organization email for
                                    association.
                                </p>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enforceDomains"
                                        id="enforceDomains" />
                                    <label for="enforceDomains" translate
                                        >Enforce Domain(s)</label
                                    >
                                </div>

                                <p class="form-help-text">
                                    Open signup lets anyone who visits this
                                    organization's subdomain create an account in
                                    it, with no email check. Leave this off unless
                                    the organization has asked for it.
                                </p>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="allowSubdomainSignup"
                                        id="allowSubdomainSignup" />
                                    <label for="allowSubdomainSignup"
                                        >Allow anyone visiting this
                                        organization's subdomain to sign up</label
                                    >
                                </div>

                                <p class="form-help-text">
                                    If SSO is setup, provide the details below.
                                </p>

                                <div class="icon-input">
                                    <input
                                        type="checkbox"
                                        formControlName="enableSso"
                                        id="enableSaml2" />
                                    <label for="enableSaml2">Enable SSO</label>
                                </div>

                                <div
                                    class="sso-config-section"
                                    *ngIf="orgEditForm.get('enableSso').value">
                                    <div
                                        class="legacy-sso-notice"
                                        *ngIf="
                                            organization?.auth
                                                ?.hasLegacySsoConfig
                                        ">
                                        <strong
                                            >Legacy SSO configuration
                                            detected.</strong
                                        >
                                        This organization has saved SSO settings
                                        but no Identity Provider Entity ID.
                                        Contact the engineering team to migrate
                                        this organization.
                                    </div>
                                    <div formGroupName="auth">
                                        <p class="form-help-text">
                                            Provide the Identity Provider Entity
                                            ID for SSO configuration.
                                        </p>

                                        <div class="app-c-form-group">
                                            <label
                                                class="app-c-form--label"
                                                for="idp-entity-id"
                                                >Idp Entity ID</label
                                            >
                                            <input
                                                class="app-c-form-control"
                                                type="text"
                                                formControlName="idpEntityId"
                                                id="idp-entity-id" />
                                        </div>
                                    </div>
                                    <div
                                        class="error-message"
                                        *ngIf="
                                            auth.controls['idpEntityId']
                                                .touched &&
                                            auth.controls['idpEntityId']
                                                .value === ''
                                        ">
                                        The organization has SSO enabled but no
                                        Entity ID is specified. Disable SSO
                                        until an Entity ID can be saved.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Resources'">
                        <resources-edit
                            [resources]="organization"
                            (onResourceSetChange)="resourceSetChanged($event)">
                        </resources-edit>
                    </my-tab>

                    <my-tab [tabTitle]="'Integration(s)'">
                        <div
                            class="form-wrapper-80"
                            formGroupName="integrations">
                            <div class="app-c-form-group">
                                <label class="app-c-form--label"
                                    >TogetherAll sso login link</label
                                >
                                <input
                                    class="app-c-form-control"
                                    type="text"
                                    formControlName="togetherAllSsoLink" />
                            </div>
                        </div>
                    </my-tab>

                    <my-tab [tabTitle]="'Tenant(s)'">
                        <div class="form-wrapper-80" formGroupName="tenants">
                            <div
                                class="tenant-item"
                                *ngFor="
                                    let tenant of tenantList.controls;
                                    let i = index
                                "
                                [formGroupName]="i">
                                <label class="toggle-switch">
                                    <input
                                        type="checkbox"
                                        formControlName="enabled" />
                                    <span class="toggle-slider"></span>
                                </label>
                                <span class="toggle-label">{{
                                    tenant.value.name
                                }}</span>
                            </div>
                        </div>
                    </my-tab>

                    <my-tab
                        [tabTitle]="'Employers'"
                        *ngIf="orgEditForm.get('ServiceType')?.value === 2">
                        <div class="form-wrapper-80">
                            <p>
                                Manage the list of employers for this EAP
                                organization. End users will select their
                                employer during signup.
                            </p>

                            <!-- Add new employer -->
                            <div class="margintop20 eap-employers-add-row">
                                <mat-form-field class="eap-name-field">
                                    <mat-label>Employer Name</mat-label>
                                    <input
                                        matInput
                                        [(ngModel)]="newEmployerName"
                                        [ngModelOptions]="{ standalone: true }"
                                        placeholder="Enter employer name" />
                                </mat-form-field>
                                <mat-form-field class="eap-code-field">
                                    <mat-label>Code (optional)</mat-label>
                                    <input
                                        matInput
                                        [(ngModel)]="newEmployerCode"
                                        [ngModelOptions]="{ standalone: true }"
                                        placeholder="e.g. EMP001" />
                                </mat-form-field>
                                <button
                                    type="button"
                                    mat-raised-button
                                    color="primary"
                                    class="eap-add-button"
                                    (click)="addEmployer()"
                                    [disabled]="!newEmployerName.trim()">
                                    Add
                                </button>
                            </div>

                            <!-- Import -->
                            <div class="margintop20 eap-employers-import">
                                <h4>Import Employers</h4>
                                <p class="eap-import-description">
                                    Upload a .xlsx or .csv file with a required
                                    <strong>Name</strong> column. An optional
                                    <strong>Code</strong> column can be included
                                    to match against existing employers (rows
                                    with a matching Code will be updated). Rows
                                    without a Code will be auto-coded. Rows
                                    missing a Name will be skipped.
                                </p>
                                <div class="eap-import-controls">
                                    <input
                                        type="file"
                                        accept=".xlsx,.csv"
                                        (change)="
                                            onEmployerFileChange($event)
                                        " />
                                    <button
                                        type="button"
                                        mat-raised-button
                                        (click)="importEmployers()"
                                        [disabled]="!employerFile">
                                        Import
                                    </button>
                                </div>
                                <p
                                    *ngIf="employerImportMessage"
                                    class="eap-import-message">
                                    {{ employerImportMessage }}
                                </p>
                            </div>

                            <!-- Export -->
                            <div
                                class="margintop20 eap-employers-export"
                                *ngIf="employers.length > 0">
                                <button
                                    type="button"
                                    mat-raised-button
                                    (click)="exportEmployers()">
                                    <i class="fa fa-download"></i> Export
                                    Employers (CSV)
                                </button>
                            </div>

                            <!-- Employer list -->
                            <div class="margintop20 eap-employers-list">
                                <h4>Employers ({{ employers.length }})</h4>
                                <mat-form-field
                                    *ngIf="employers.length > 0"
                                    class="eap-table-search"
                                    appearance="outline">
                                    <mat-label>Search employers</mat-label>
                                    <input
                                        matInput
                                        [(ngModel)]="employerTableSearch"
                                        [ngModelOptions]="{ standalone: true }"
                                        (ngModelChange)="filterEmployerTable()"
                                        placeholder="Filter by name or code..." />
                                </mat-form-field>
                                <table *ngIf="employers.length > 0">
                                    <thead>
                                        <tr>
                                            <th
                                                class="col-name sortable"
                                                (click)="sortEmployers('name')">
                                                Name
                                                <i
                                                    class="fa"
                                                    [ngClass]="
                                                        getSortIcon('name')
                                                    "></i>
                                            </th>
                                            <th
                                                class="col-code sortable"
                                                (click)="sortEmployers('code')">
                                                Code
                                                <i
                                                    class="fa"
                                                    [ngClass]="
                                                        getSortIcon('code')
                                                    "></i>
                                            </th>
                                            <th
                                                class="col-active sortable"
                                                (click)="
                                                    sortEmployers('active')
                                                ">
                                                Active
                                                <i
                                                    class="fa"
                                                    [ngClass]="
                                                        getSortIcon('active')
                                                    "></i>
                                            </th>
                                            <th class="col-actions">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            *ngFor="
                                                let employer of filteredEmployerList
                                            ">
                                            <ng-container
                                                *ngIf="
                                                    editingEmployer?.id !==
                                                    employer.id
                                                ">
                                                <td class="col-name">
                                                    {{ employer.name }}
                                                </td>
                                                <td class="col-code">
                                                    {{ employer.code }}
                                                </td>
                                                <td class="col-active">
                                                    <span
                                                        [ngClass]="
                                                            employer.active
                                                                ? 'active-yes'
                                                                : 'active-no'
                                                        "
                                                        >{{
                                                            employer.active
                                                                ? 'Yes'
                                                                : 'No'
                                                        }}</span
                                                    >
                                                </td>
                                                <td class="col-actions">
                                                    <button
                                                        type="button"
                                                        mat-icon-button
                                                        (click)="
                                                            startEditEmployer(
                                                                employer
                                                            )
                                                        "
                                                        title="Edit">
                                                        <i
                                                            class="fa fa-pencil"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        mat-icon-button
                                                        (click)="
                                                            deleteEmployer(
                                                                employer
                                                            )
                                                        "
                                                        *ngIf="employer.active"
                                                        title="Deactivate">
                                                        <i
                                                            class="fa fa-ban"></i>
                                                    </button>
                                                </td>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="
                                                    editingEmployer?.id ===
                                                    employer.id
                                                ">
                                                <td class="col-name">
                                                    <input
                                                        matInput
                                                        [(ngModel)]="
                                                            editingEmployer.name
                                                        "
                                                        [ngModelOptions]="{
                                                            standalone: true,
                                                        }"
                                                        class="edit-input" />
                                                </td>
                                                <td class="col-code">
                                                    <input
                                                        matInput
                                                        [(ngModel)]="
                                                            editingEmployer.code
                                                        "
                                                        [ngModelOptions]="{
                                                            standalone: true,
                                                        }"
                                                        class="edit-input" />
                                                </td>
                                                <td class="col-active">
                                                    <mat-slide-toggle
                                                        [(ngModel)]="
                                                            editingEmployer.active
                                                        "
                                                        [ngModelOptions]="{
                                                            standalone: true,
                                                        }"></mat-slide-toggle>
                                                </td>
                                                <td class="col-actions">
                                                    <button
                                                        type="button"
                                                        mat-icon-button
                                                        (click)="
                                                            saveEditEmployer()
                                                        "
                                                        title="Save">
                                                        <i
                                                            class="fa fa-check icon-confirm"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        mat-icon-button
                                                        (click)="
                                                            cancelEditEmployer()
                                                        "
                                                        title="Cancel">
                                                        <i
                                                            class="fa fa-times icon-cancel"></i>
                                                    </button>
                                                </td>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </table>
                                <p
                                    *ngIf="employers.length === 0"
                                    class="eap-employers-empty">
                                    No employers added yet. Add employers above
                                    or import from a spreadsheet.
                                </p>
                            </div>
                        </div>
                    </my-tab>
                    <my-tab [tabTitle]="'Branding'">
                        <div
                            class="form-wrapper-80"
                            formGroupName="brandingGroup">
                            <p>
                                This is designated for the purposes of
                                configuring a customized client branding page
                                which will consist of a leaderboard image, a
                                client logo (different from the one already
                                uploaded), and a description.
                            </p>

                            <div
                                *ngIf="
                                    organization.brandingGroup
                                        ?.brandingClientLogo
                                ">
                                <img
                                    [alt]="organization.name"
                                    [src]="
                                        organization.brandingGroup
                                            ?.brandingClientLogo
                                    "
                                    style="
                                        max-width: 300px;
                                        max-height: 200px;
                                        height: auto;
                                    " />
                            </div>
                            <div class="icon-input">
                                <label for="clientLogo">Client Logo</label>
                                <input
                                    type="file"
                                    (change)="
                                        brandingUpload($event, 'clientLogo')
                                    "
                                    #input />
                            </div>

                            <div
                                *ngIf="
                                    organization.brandingGroup
                                        ?.brandingCoverPhoto
                                ">
                                <img
                                    [alt]="organization.name"
                                    [src]="
                                        organization.brandingGroup
                                            ?.brandingCoverPhoto
                                    "
                                    style="
                                        max-width: 300px;
                                        max-height: 200px;
                                        height: auto;
                                    " />
                            </div>
                            <div class="icon-input">
                                <label for="coverStylePhoto"
                                    >Cover Style Photo</label
                                >
                                <input
                                    type="file"
                                    (change)="
                                        brandingUpload($event, 'coverPhoto')
                                    "
                                    #input />
                            </div>

                            <div class="icon-input">
                                <label for="description" translate
                                    >Description</label
                                >
                                <ckeditor
                                    [editor]="Editor"
                                    formControlName="brandingDescription"
                                    [config]="config"
                                    id="description">
                                </ckeditor>
                            </div>
                        </div>
                    </my-tab>
                </my-tabs>

                <div class="fixed-footer">
                    <div class="form-wrapper-80">
                        <div class="validation-banner" *ngIf="errors">
                            {{ errors }}
                        </div>
                        <button
                            tabindex="0"
                            class="app-c-btn app-c-btn--primary app-c-btn--curve footer-save-btn">
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
